export default { //全局state
  loginState: {
    isLogin: false,
    userInfo: {
      phone: '',
      displayPhone: '',
      headImg: ''
    },
    theme: {
      code: '',
      colour: '',
      createBy: '',
      createTime: '',
      delFlag: '',
      drillValue: '',
      id: '',
      logoImg: '',
      name: '',
      seq: '',
      slogan: '',
      status: '',
      updateBy: '',
      updateTime: '',
    },
  },
  token: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js